module.exports = __webpack_public_path__ + "static/images/import.8c410087cfbd35cf9293cf1c32756c51.svg";